import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { AppLayout } from './components/AppLayout'
import { HomeScreen } from './screens/HomeScreen'
import { CalendarScreen } from './screens/CalendarScreen'
import { TicketsScreen } from './screens/TicketsScreen'
import { PeopleScreen } from './screens/PeopleScreen'
import { YouScreen } from './screens/YouScreen'
import { EventDetailScreen } from './screens/EventDetailScreen'
import { IncidentScreen } from './screens/IncidentScreen'
import { VolunteersScreen } from './screens/VolunteersScreen'
import { CheckInScreen } from './screens/CheckInScreen'
import { EventDashboardScreen } from './screens/EventDashboardScreen'
import { SettingsScreen } from './screens/SettingsScreen'
import { LoginScreen } from './screens/LoginScreen'
import { RegisterScreen } from './screens/RegisterScreen'
import { CreateEventScreen } from './screens/CreateEventScreen'
import { OrganisationsScreen } from './screens/OrganisationsScreen'
import { ArtistsScreen } from './screens/ArtistsScreen'

const routes = [
  { path: '/login', element: <LoginScreen /> },
  { path: '/register', element: <RegisterScreen /> },
  { path: '/', element: <AppLayout />, children: [
    { index: true, element: <HomeScreen /> },
    { path: 'create', element: <CreateEventScreen /> },
    { path: 'calendar', element: <CalendarScreen /> },
    { path: 'tickets', element: <TicketsScreen /> },
    { path: 'people', element: <PeopleScreen /> },
    { path: 'organisations', element: <OrganisationsScreen /> },
    { path: 'artists', element: <ArtistsScreen /> },
    { path: 'you', element: <YouScreen /> },
    { path: 'settings', element: <SettingsScreen /> },
    { path: 'event/:id', element: <EventDetailScreen /> },
    { path: 'event/:eventId/incident', element: <IncidentScreen /> },
    { path: 'event/:eventId/volunteers', element: <VolunteersScreen /> },
    { path: 'event/:eventId/checkins', element: <CheckInScreen /> },
    { path: 'event/:eventId/dashboard', element: <EventDashboardScreen /> },
    { path: 'event/:eventId/tickets', element: <TicketsScreen /> },
  ]},
]

const router = createBrowserRouter(routes)

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
